import { required } from 'vuelidate/lib/validators'

export default {
  search: {
    agenda_id: {
      required
    },
    date_start: {
      required
    },
    date_end: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/resources/validations.js